export const LOADING_DASHBOARD_JEFE = "LOADING_DASHBOARD_JEFE";
export const GET_DASHBOARD_JEFE = "GET_DASHBOARD_JEFE";
export const DASHBOARD_JEFE_FAIL = "DASHBOARD_JEFE_FAIL";

